/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnMovingSeparator } from './igr-column-moving-separator';
import { ColumnMovingSeparator } from './ColumnMovingSeparator';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnMovingSeparatorModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnMovingSeparatorModule() {
    }
    IgrColumnMovingSeparatorModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnMovingSeparator", IgrColumnMovingSeparator);
        TypeRegistrar.register("ColumnMovingSeparator", ColumnMovingSeparator.$type);
    };
    return IgrColumnMovingSeparatorModule;
}());
export { IgrColumnMovingSeparatorModule };
//# sourceMappingURL=igr-column-moving-separator-module.js.map
